var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.parsed)?_c('div',[_c('div',[_vm._v(" "+_vm._s(_vm.data)+" ")]),_c('div',[_vm._v(" "+_vm._s(_vm.parsed.userId)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }